import React, { Component } from "react";
import Breadcrumbs from 'core/components/SecondaryHeader'
import {Wrapper} from './components/Styled'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import LazyImage from 'core/components/LazyImage'
import Accordion from "../../../../core/components/Accordion";
import PuppySeekerNav from "../PuppySeekerNav";

class PuppyQuestions extends Component {

  constructor(props) {
    super(props)
  }

  static defaultProps = {
    title: '',
    cms: {},
  }

  static propTypes = {
    cms: PropTypes.object.isRequired,
  }
  
  getLeftItems () {
    return [
      {
        text: 'Home',
        isLink: true,
        isActive: true,
        props: {
          href: '/'
        }
      },
      {
        text: 'Questions for Your Breeder',
        isLink: false,
        isActive: false,
        props: {
          href: '/'
        }
      }
    ]
  }

  removeHTMLtags( string ) {
    let regex = /(<([^>]+)>)/ig
    return (string) ? string.replace(regex, "") : ''
  } 

  render() {

    return (
      <div>
      <div className='marketplace__top-image'>

        <Breadcrumbs items={this.getLeftItems()} />

      </div>

      <Wrapper className={`static-page`}>
        <div className='static-page__section'>
          <div className='header' >
              <h1> 
                  { this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-heading'] ) }
              </h1>
          </div>
          <PuppySeekerNav />
          <div className='section-1' >
              <div className='img-wrap' >
                  <LazyImage src={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-section-1-image'] ) }  className='section-1-img' />
              </div>
              <div className='text-wrap' >
                  <h2>
                      { this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-section-1-heading'] ) }
                  </h2>
                  <p dangerouslySetInnerHTML={{ __html:  this.props.cms['questions-to-ask-breeder-section-1-text']  }} /> 
              </div>
          </div>
          <div>

          <div className='section-2' >
            <h2> { this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-section-2-heading'] ) }</h2>

            <div className="accordion-wrap" >
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-1-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-1-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-2-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-2-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-3-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-3-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-4-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-4-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-5-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-5-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-6-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-6-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-7-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-7-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-8-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-8-title'] )}/>
              <Accordion content={ this.props.cms['questions-to-ask-breeder-accordion-9-content'] } title={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-accordion-9-title'] )}/>
            </div>
          </div>

            <div className='section-3' >
                <div className='text-wrap' >
                  <h2> { this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-section-3-heading'] ) } </h2>
                      <a className="button" target="_blank" href={ this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-section-3-button-link'] ) } >
                            { this.removeHTMLtags( this.props.cms['questions-to-ask-breeder-section-3-button-text'] ) }
                      </a>
                </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
    )
  }

  }

  const mapStateToProps = state => ({
    cms: state.app.cms,
  })

  export default connect(
    mapStateToProps,
    null
  )(PuppyQuestions)
  